import { Button } from '@src/design-system/button';
import { cn } from '@src/design-system/helpers';
import { Category, HambergerMenu } from 'iconsax-react';

import { useReminderTemplatesStore } from '../store/reminder-templates-store';

type TemplatesLayoutSwitcherProps = {
  className?: string;
};

export const TemplatesLayoutSwitcher = ({
  className,
}: TemplatesLayoutSwitcherProps) => {
  const { isTableMode, setIsTableMode } = useReminderTemplatesStore();

  return (
    <div
      className={cn(
        'flex border border-primary-200 rounded-xl overflow-hidden',
        className
      )}
    >
      <Button
        variant='ghost'
        size='sm'
        onClick={() => setIsTableMode(false)}
        className={cn(
          'rounded-none border-0 h-10 px-2',
          !isTableMode
            ? 'bg-primary-200 text-primary-900 hover:bg-primary-200 hover:text-primary-900'
            : 'hover:bg-primary-50'
        )}
        title='Card View'
      >
        <Category className='h-6 w-6' />
      </Button>

      <Button
        variant='ghost'
        size='sm'
        onClick={() => setIsTableMode(true)}
        className={cn(
          'rounded-none border-0 h-10 px-2 border-l border-primary-200',
          isTableMode
            ? 'bg-primary-200 text-primary-900 hover:bg-primary-200 hover:text-primary-900'
            : 'hover:bg-primary-50'
        )}
        title='Table View'
      >
        <HambergerMenu className='h-6 w-6' />
      </Button>
    </div>
  );
};
